<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-responsive`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.667 6H4.333C3.045 6 2 6.895 2 8v32c0 1.105 1.045 2 2.333 2h39.334C44.955 42 46 41.105 46 40V8c0-1.105-1.045-2-2.333-2zM6 38V10h36v28H6zm26-16h-4a1 1 0 00-1 1v2a1 1 0 001 1h4v2a1 1 0 001.6.8l5.333-4a1 1 0 000-1.6l-5.333-4a1 1 0 00-1.6.8v2zm-12 0h-4v-2a1 1 0 00-1.6-.8l-5.333 4a1 1 0 000 1.6l5.333 4A1 1 0 0016 28v-2h4a1 1 0 001-1v-2a1 1 0 00-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconResponsive',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
